import axios from '@/api/http_client';
import {getExportApi} from '@/api/downloadApi';

function downloadFilename(disposition, format) {
  const encoded = /filename\*=UTF-8''([^;]+)/i.exec(disposition || '');
  const plain = /filename="([^"]+)"|filename=([^;]+)/i.exec(disposition || '');
  let filename = plain ? (plain[1] || plain[2]).trim() : `products.${format === 'excel' ? 'xlsx' : format}`;
  if (encoded) {
    try {
      filename = decodeURIComponent(encoded[1]);
    } catch (err) {
    }
  }
  return filename.replace(/[\\/]/g, '_');
}

export async function exportFile(type, format, params = {}) {
  const endpoint = getExportApi(type);
  if (!endpoint) throw new Error('Unsupported export type');
  if (!format) throw new Error('An export format is required');
  const {id, ...query} = params;
  const needsId = ['group', 'category', 'category2'].includes(type);
  // if (needsId && (id == null || String(id) === '')) {
  //   throw new Error('A group or category ID is required');
  // }
  const response = await axios({
    url: needsId ? `${endpoint}${encodeURIComponent(String(id))}` : endpoint,
    method: 'GET',
    params: {...query, format},
    responseType: 'blob',
    headers: {Location: localStorage.getItem('warehouseLocationWeb')}
  });
  const contentType = response.headers['content-type'] || '';
  if (format === 'pdf') {
    if (!response.data.size || /json|text\/html/i.test(contentType)) {
      throw new Error('The response does not contain a PDF file.');
    }
    return new Blob([response.data], {type: 'application/pdf'});
  }
  // if (/json|text\/html/i.test(contentType) || !response.data.size) {
  //   throw new Error('The export response does not contain a file.');
  // }
  const url = URL.createObjectURL(response.data);
  const link = document.createElement('a');
  try {
    link.href = url;
    link.download = downloadFilename(response.headers['content-disposition'], format);
    document.body.appendChild(link);
    link.click();
  } finally {
    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
}



// WEBPACK FOOTER //
// ./src/common/exportFile.js